const copyToClipBoard = (URL: string) => {
  const selBox = document.createElement('textarea');
  selBox.value = URL;

  document.body.appendChild(selBox);
  selBox.select();

  document.execCommand('copy');
  document.body.removeChild(selBox);
};

export default copyToClipBoard;
